/* Portafoto v13: advisory shipping estimate. Never gates/intercepts checkout. */
(() => {
  'use strict';
  if (window.__pfShippingV13) return;
  window.__pfShippingV13 = true;
  const EN = document.documentElement.lang.toLowerCase().startsWith('en');
  const KEY = 'portafoto_shipping_province';
  const provinces = [
    ['SU','السادس من أكتوبر','6th of October',150],['C','القاهرة','Cairo',150],
    ['GZ','الجيزة','Giza',150],['HU','حلوان','Helwan',150],['SHR','الشرقية','Sharqia',175],
    ['ALX','الإسكندرية','Alexandria',175],['ASN','أسوان','Aswan',175],['AST','أسيوط','Assiut',175],
    ['BH','البحيرة','Beheira',175],['BNS','بني سويف','Beni Suef',175],['DK','الدقهلية','Dakahlia',175],
    ['DT','دمياط','Damietta',175],['FYM','الفيوم','Fayoum',175],['GH','الغربية','Gharbia',175],
    ['IS','الإسماعيلية','Ismailia',175],['KFS','كفر الشيخ','Kafr El Sheikh',175],
    ['LX','الأقصر','Luxor',175],['MT','مطروح','Matrouh',175],['MN','المنيا','Minya',175],
    ['MNF','المنوفية','Monufia',175],['WAD','الوادي الجديد','New Valley',175],
    ['SIN','شمال سيناء','North Sinai',175],['PTS','بورسعيد','Port Said',175],['KB','القليوبية','Qalyubia',175],
    ['KN','قنا','Qena',175],['SHG','سوهاج','Sohag',175],['SUZ','السويس','Suez',175],
    ['BA','البحر الأحمر — الغردقة','Red Sea — Hurghada',250],['JS','جنوب سيناء — شرم الشيخ ودهب','South Sinai — Sharm El Sheikh & Dahab',250]
  ];
  let memoryProvince = '';
  try { memoryProvince = sessionStorage.getItem(KEY) || ''; } catch (_) {}
  const registry = new Map();
  const observed = new WeakSet();
  let serial = 0, timer = 0;
  const money = cents => new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100) + (EN ? ' EGP' : ' ج.م');
  const put = (node, text) => { if (node.textContent !== text) node.textContent = text; };
  const installation = () => window.PortafotoInstallationActive === true || !!document.querySelector('[data-epc-visit], .cart-item a[href*="/products/electrical-panel-installation-visit"], .previewCartItem a[href*="/products/electrical-panel-installation-visit"]');
  const available = () => installation() ? provinces.filter(p => p[0] === 'C' || p[0] === 'GZ') : provinces;

  function create(button) {
    if (registry.has(button) || !button.parentElement) return;
    const id = 'pf-shipping-v13-' + (++serial);
    const box = document.createElement('section');
    box.className = 'pf-shipping-estimator';
    box.dir = EN ? 'ltr' : 'rtl';
    box.innerHTML = `<div class="pf-shipping-estimator__title">${EN ? 'Estimate shipping (optional)' : 'تقدير الشحن (اختياري)'}</div>
      <label class="pf-shipping-estimator__label" for="${id}">${EN ? 'Governorate' : 'المحافظة'}</label>
      <select class="pf-shipping-estimator__select" id="${id}" aria-describedby="${id}-notice"></select>
      <div class="pf-shipping-estimator__summary" hidden>
        <div><span>${EN ? 'Estimated shipping' : 'الشحن التقريبي'}</span><strong data-pf-shipping-cost></strong></div>
        <div class="pf-shipping-estimator__grand" hidden><span>${EN ? 'Estimated total' : 'الإجمالي التقريبي'}</span><strong data-pf-shipping-grand></strong></div>
      </div>
      <p class="pf-shipping-estimator__notice" id="${id}-notice">${EN ? 'You can proceed without choosing here. Final shipping and eligibility are confirmed using your address at checkout.' : 'تقدر تكمل الطلب من غير اختيار هنا. الشحن النهائي وإمكانية التوصيل بيتأكدوا حسب العنوان في صفحة الدفع.'}</p>`;
    button.parentElement.insertBefore(box, button);
    const select = box.querySelector('select');
    let optionScope = '';
    const render = () => {
      if (!box.isConnected) return;
      const entries = available();
      const scope = entries.map(p => p[0]).join(',');
      if (scope !== optionScope) {
        select.replaceChildren(new Option(EN ? 'Choose to estimate shipping' : 'اختار لحساب الشحن التقريبي', ''));
        entries.forEach(p => select.add(new Option(p[EN ? 2 : 1], p[0])));
        optionScope = scope;
      }
      const match = entries.find(p => p[0] === memoryProvince);
      const nextValue = match ? match[0] : '';
      if (select.value !== nextValue) select.value = nextValue;
      const summary = box.querySelector('.pf-shipping-estimator__summary');
      if (summary.hidden !== !match) summary.hidden = !match;
      if (!match) return;
      put(box.querySelector('[data-pf-shipping-cost]'), money(match[3] * 100));
      /* Read ONLY Shopify's post-discount cents attribute. Never parse price text
         and never recalculate an automatic discount in browser JavaScript. */
      const cartScope = button.closest('.previewCartInfo, [data-cart-total], .cart-content-item, form');
      const amountNode = cartScope && cartScope.querySelector('[data-cart-total-value]');
      const raw = amountNode && amountNode.getAttribute('data-cart-total-value');
      const valid = raw !== null && /^\d+$/.test(raw || '');
      const grand = box.querySelector('.pf-shipping-estimator__grand');
      if (grand.hidden !== !valid) grand.hidden = !valid;
      if (valid) put(box.querySelector('[data-pf-shipping-grand]'), money(Number(raw) + match[3] * 100));
    };
    select.addEventListener('change', () => {
      memoryProvince = select.value;
      try { sessionStorage.setItem(KEY, memoryProvince); } catch (_) {}
      renderAll();
    });
    registry.set(button, {box, render});
    render();
    // No required select, cart attributes, click handler, or submit handler.
  }
  function renderAll() {
    registry.forEach((entry, button) => {
      if (!button.isConnected || !entry.box.isConnected) registry.delete(button);
      else entry.render();
    });
  }
  function relevant(record) {
    const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
    return !target?.closest('.pf-shipping-estimator');
  }
  function schedule() {
    if (timer) return;
    timer = window.setTimeout(() => { timer = 0; boot(); }, 60);
  }
  function boot() {
    document.querySelectorAll('#cart-sidebar-checkout, #cart-checkout').forEach(create);
    document.querySelectorAll('#halo-cart-sidebar, .template-cart #main-cart-items').forEach(region => {
      if (observed.has(region)) return;
      observed.add(region);
      new MutationObserver(records => { if (records.some(relevant)) schedule(); }).observe(region, {
        childList:true, subtree:true, attributes:true, attributeFilter:['data-cart-total-value']
      });
    });
    renderAll();
    guardElectricalPanelSubmit();
  }
  function fixProductScroll() {
    if (!matchMedia('(max-width:767px)').matches) return;
    document.querySelectorAll('.productView-for.slick-initialized').forEach(slider => {
      if (slider.dataset.pfScrollFixed === 'true') return;
      try {
        if (window.jQuery?.fn?.slick) {
          const $slider = window.jQuery(slider);
          $slider.slick('slickSetOption',{swipe:false,draggable:false,touchMove:false},false);
          $slider.find('.slick-list').off('touchstart.slick touchmove.slick touchend.slick touchcancel.slick mousedown.slick mousemove.slick mouseup.slick');
          slider.dataset.pfScrollFixed = 'true';
        }
      } catch (_) {}
    });
  }
  // Preserve the existing electrical-panel duplicate-submit guard.
  function guardElectricalPanelSubmit() {
    document.querySelectorAll('[data-epc-form]').forEach(form => {
      if (form.dataset.pfSubmitGuard === 'true') return;
      form.dataset.pfSubmitGuard = 'true';
      const button = form.querySelector('[data-epc-submit]');
      const label = button?.querySelector('[data-epc-submit-label]');
      const idle = label?.textContent;
      window.addEventListener('pageshow', event => {
        if (!event.persisted || !form.isConnected) return;
        delete form.dataset.pfSubmitting;
        if (button) button.disabled = false;
        if (label && idle) label.textContent = idle;
      });
      form.addEventListener('submit', event => {
        if (event.defaultPrevented) return;
        if (form.dataset.pfSubmitting === 'true') {
          event.preventDefault();event.stopImmediatePropagation();return;
        }
        form.dataset.pfSubmitting = 'true';
        if (button) button.disabled = true;
        if (label) label.textContent = EN ? 'Adding…' : 'جاري الإضافة…';
      });
    });
  }
  // Existing cart-remove fallback, isolated from checkout. Use the real line key;
  // on failure never delete a guessed first line. Bound network wait to 6 seconds.
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-cart-remove][data-line]');
    if (!button || !button.closest('#halo-cart-sidebar, #main-cart-items')) return;
    event.preventDefault();event.stopImmediatePropagation();
    if (button.dataset.pfRemoving === 'true') return;
    button.dataset.pfRemoving = 'true';button.setAttribute('aria-busy','true');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(),6000);
    try {
      const root=String(window.Shopify?.routes?.root || '/').replace(/\/$/,'');
      const response=await fetch(root+'/cart/change.js',{
        method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:button.dataset.line,quantity:0}),signal:controller.signal
      });
      if(!response.ok)throw new Error('Cart remove failed');
      /* v16: in the drawer, refresh it in place with the theme's own renderer.
         A full reload closed the drawer and dropped the customer back on the
         page underneath, which read as "removing one item threw me out".
         The cart page itself still reloads — the customer stays on /cart. */
      const cart = await response.json().catch(() => null);
      const refresh = window.sharedFunctions && window.sharedFunctions.updateSidebarCart;
      if (cart && typeof refresh === 'function' && button.closest('#halo-cart-sidebar')) {
        refresh(cart);
        document.dispatchEvent(new CustomEvent('cart:updated', {detail:{cart}}));
        return;
      }
      location.reload();
    } catch (_) {
      delete button.dataset.pfRemoving;button.removeAttribute('aria-busy');
      let error=button.parentElement.querySelector('[data-pf-remove-error]');
      if(!error){error=document.createElement('p');error.dataset.pfRemoveError='';error.setAttribute('role','alert');button.parentElement.appendChild(error);}
      error.textContent=EN?'Could not remove the item. Please retry.':'تعذر حذف المنتج. جرّب تاني.';
    } finally { clearTimeout(timeout); }
  },true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot,{once:true});
  else boot();
  ['cart:updated','cart:refresh','epc:installationstate','shopify:section:load'].forEach(name => document.addEventListener(name,schedule));
  window.addEventListener('pageshow',schedule);
  window.addEventListener('load',fixProductScroll,{once:true});
})();
